// extracted by mini-css-extract-plugin
export default {"select":"_2cYXw-JIELOMq7x0aFnB4a","multilanguage":"_1uvJ8XoFadHbH4Yna2cRc"};